import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TrueGrit} from "../../TrueGrit";
import {gsap} from "gsap";
import {TrueGritSound} from "../../sound/TrueGritSound";
import {TrueGritGameMode} from "../../server/TrueGritGameMode";
import {BigWinLevel, TrueGritWinConfigs} from "../../configs/TrueGritWinConfigs";
import {TrueGritSymbol} from "../../reels/TrueGritSymbol";

/**
 * Created by Jerker Nord on 2021-09-25.
 */

export class TrueGritMaxWinRunner implements SimplePresentation {

    constructor() {}

    shouldRun():boolean {
        return TrueGrit.model.data.brokeBank;
    }

    start(controller:SimplePresentationRunnerController):void {
        const levels:BigWinLevel[] = TrueGritWinConfigs.getBigWinLevels(20220);

        const tl:gsap.core.Timeline = gsap.timeline();
        TrueGrit.totalBigWinView.precalculateScale(TrueGrit.model.winRatio * TrueGrit.model.gameData.playedBetValue);

        tl.add(() => TrueGrit.trueGritGritGirlSymbols.goBackAllToOffState());
        tl.add(()=>TrueGrit.keypadPlugin.setZeroBetSpinCounter(-1));
        tl.add(() => TrueGrit.soundPlayer.fadeMusic(1,0,2000));

        let introDuration = 1.425;
        let levelAborted = false;
        for(let level of levels) {
            const levelSound = this.getLevelSound(level.id);
            tl.add(()=>{levelAborted = false;});
            tl.add(()=> {TrueGrit.soundPlayer.playSound(levelSound)});
            if (level.id == 1){
                tl.add(this.getBigWinIntro(introDuration));
            }
            tl.add(() => controller.setSkipCallback(() => {
                levelAborted = true;
                tl.seek(level.name + "_end", false);
            }));

            tl.add(TrueGrit.totalBigWinView.getLevelAnimation(level.from * TrueGrit.model.gameData.playedBetValue, level.to * TrueGrit.model.gameData.playedBetValue, level.duration, level.id));
            tl.addLabel(level.name + "_end");
            tl.add(() => controller.setSkipCallback());
            tl.add(()=>{
                if(levelAborted){
                    TrueGrit.soundPlayer.stopSound(levelSound);
                }
            })
        }
        tl.add(() => {TrueGrit.soundPlayer.playSound(TrueGritSound.BIG_WIN_ENDS)});
        //tl.add(() => TrueGrit.soundPlayer.fadeMusic(0,1,1000));

        tl.add(TrueGrit.totalBigWinView.show(introDuration*0.7), introDuration - introDuration*0.7);
        tl.add(TrueGrit.totalBigWinView.getImageScalingAnimation(tl.duration()), introDuration);
        tl.add(() => TrueGrit.keypadPlugin.setWin(TrueGrit.model.data.accumulatedRoundWin, true, TrueGrit.isWinBelowStake()));

        tl.add(TrueGrit.maxWinOutroView.showMaxWinBlackout(2));
        tl.add(TrueGrit.totalBigWinView.hide(0.01));

        //MAX WIN
        tl.add(() => controller.setSkipCallback());
        tl.add(()=>{
            TrueGrit.soundPlayer.playSound(TrueGritSound.CAP_WIN_START);
        });
        tl.add(()=>TrueGrit.maxWinOutroView.startSpineLoop());
        tl.add(TrueGrit.maxWinOutroView.showOutro(() => this.outroComplete(controller),true));
        tl.add(()=>this.startCapWinMusic(), "<0.778");
        tl.add(()=>TrueGrit.maxWinOutroView.startTextLoop(), ">-0.1");
        tl.add(TrueGrit.maxWinOutroView.showButton(), ">-0.1");

    }

    private startCapWinMusic(){
        const capMusic = TrueGrit.soundPlayer.playSound(TrueGritSound.CAP_WIN_MUSIC);
        if (capMusic){
            capMusic.setLoop(true);
        }
    }

    private getLevelSound(level:number){
        return TrueGritSound.BIG_WIN_LEVEL_PREFIX  + level;

    }
    private getBigWinIntro(duration:number):gsap.core.Timeline {
        const tl = gsap.timeline();
        const symbols = TrueGrit.allReelsView.getAllVisibleSymbols();

        for (let symbol of symbols){
            tl.add((<TrueGritSymbol>symbol).getShakeAnimation(duration),0);
        }

        return tl;
    }

    private outroComplete(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:()=>controller.finish()});
        tl.add(()=>{
            TrueGrit.soundPlayer.stopSound(TrueGritSound.CAP_WIN_START);
            TrueGrit.soundPlayer.playSound(TrueGritSound.CAP_WIN_CONTINUE);
            TrueGrit.soundPlayer.stopSound(TrueGritSound.CAP_WIN_MUSIC);
            TrueGrit.soundPlayer.switchMusic(TrueGritGameMode.NORMAL);
            TrueGrit.soundPlayer.fadeMusic(0,1,1000);
        });
        tl.add(TrueGrit.maxWinOutroView.hideOutro(TrueGrit.isWinBelowStake()));
        tl.add(()=>TrueGrit.maxWinOutroView.stopSpineLoop());
        tl.add(()=>TrueGrit.maxWinOutroView.stopTextLoop());

    }
}